import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './LogoAnimation.css';
import imgV from '../Assets/v.svg';
import imgC from '../Assets/c.svg';
import imgN from '../Assets/n.svg';
import imgR from '../Assets/r.svg';
import imgL from '../Assets/l.svg';

const letters = [
  { key: 'V', image: imgV },
  { key: 'C', image: imgC },
  { key: 'N', image: imgN },
  { key: 'R', image: imgR }
];

const LogoAnimation = ({ onEnd }) => {
  const [animationPhase, setAnimationPhase] = useState(0);

  useEffect(() => {
    const phase1Timer = setTimeout(() => setAnimationPhase(1), 300);
    const phase2Timer = setTimeout(() => setAnimationPhase(2), 1800);
    const endTimer = setTimeout(() => onEnd?.(), 2500);

    return () => {
      clearTimeout(phase1Timer);
      clearTimeout(phase2Timer);
      clearTimeout(endTimer);
    };
  }, [onEnd]);

  return (
    <div className="Animatedlogo-container">
      <div className={`big-letters-wrapper ${animationPhase >= 2 ? 'move-top-left' : ''}`}>
        <motion.img
          src={imgL}
          alt="VCNR Logotype"
          className={`logotype-final1 ${animationPhase >= 1 ? 'active' : ''}`}
          initial={{ x: -100, opacity: 0 }}
          animate={{
            x: animationPhase >= 1 ? 0 : -100,
            opacity: animationPhase >= 1 ? 1 : 0
          }}
          transition={{ 
            duration: 0.8,
            delay: 0.1,
            ease: [0.16, 1, 0.3, 1]
          }}
        />
        <div className="big-letters">
          {letters.map((item, index) => (
            <motion.div
              key={index}
              className="letter-container"
              initial={{ x: -100, opacity: 0 }}
              animate={{
                x: animationPhase >= 1 ? 0 : -100,
                opacity: animationPhase >= 1 ? 1 : 0
              }}
              transition={{ 
                duration: 0.6,
                delay: index * 0.1,
                ease: [0.2, 1, 0.3, 1]
              }}
            >
              <img
                src={item.image}
                alt={item.key}
                className={`letter-img ${animationPhase >= 1 ? 'active' : ''}`}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoAnimation;